import { httpsCallable } from 'firebase/functions';
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { db, functions } from './firebase';

const configureReminderCallable = httpsCallable(functions, 'configureMedicationReminder');
const configureRoundCallable = httpsCallable(functions, 'configureMedicationRound');
const recordAdministrationCallable = httpsCallable(functions, 'recordMedicationAdministration');
const recordRoundCallable = httpsCallable(functions, 'recordMedicationRound');

const serializeTimestamp = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const configureMedicationReminder = async (medicationId, schedule) => {
  const result = await configureReminderCallable({ medicationId, schedule });
  return result.data;
};

export const configureMedicationRound = async (childId, round, roundId = '') => {
  const result = await configureRoundCallable({ childId, roundId, round });
  return result.data;
};

export const recordMedicationAdministration = async (occurrenceId, administration) => {
  const result = await recordAdministrationCallable({ occurrenceId, ...administration });
  return result.data;
};

export const recordMedicationRound = async (administrations) => {
  const normalized = administrations.map((item) => ({
    ...item,
    ...(item.status === 'taken' && item.actualTakenAt ? { actualTakenAt: new Date(item.actualTakenAt).toISOString() } : {}),
  }));
  const result = await recordRoundCallable({
    occurrenceIds: normalized.map((item) => item.occurrenceId),
    administrations: normalized,
  });
  return result.data;
};

export const fetchMedicationOccurrence = async (occurrenceId) => {
  const snapshot = await getDoc(doc(db, 'medicationOccurrences', occurrenceId));
  if (!snapshot.exists()) return null;
  const data = snapshot.data();
  return { id: snapshot.id, ...data, scheduledFor: serializeTimestamp(data.scheduledFor), recordedAt: serializeTimestamp(data.recordedAt), actualTakenAt: serializeTimestamp(data.actualTakenAt) };
};

export const subscribeToMedicationReminderSchedules = (childId, onChange, onError) => {
  if (!childId) return () => {};
  return onSnapshot(
    query(collection(db, 'medicationReminderSchedules'), where('childId', '==', childId)),
    (snapshot) => onChange(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
    onError
  );
};

export const subscribeToMedicationReminderRounds = (childId, onChange, onError) => {
  if (!childId) return () => {};
  return onSnapshot(query(collection(db, 'medicationReminderRounds'), where('childId', '==', childId)),
    (snapshot) => onChange(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))), onError);
};

export const subscribeToMedicationOccurrences = (childId, onChange, onError) => {
  if (!childId) return () => {};
  return onSnapshot(
    query(collection(db, 'medicationOccurrences'), where('childId', '==', childId)),
    (snapshot) => onChange(snapshot.docs.map((item) => ({
      id: item.id,
      ...item.data(),
      scheduledFor: serializeTimestamp(item.data().scheduledFor),
      recordedAt: serializeTimestamp(item.data().recordedAt),
    }))),
    onError
  );
};
